import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color='currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} class={customClass} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7 14L12 9L17 14H7Z' fill={color} />
  </svg>
)
